const isEmpty = (value) => {
  return value === null || value === undefined || value === '';
};

export const getKeyByLanguage = (key, language) =>
    `${key}${language?.charAt(0).toUpperCase()}${language
        ?.slice(1)
        .toLowerCase()}`;
 
export const getByLanguage = (
    resource,
    property,
    language,
    strict = false
) => {
    if (!resource || typeof resource !== "object") {
        return "";
    }
    const value = resource[getKeyByLanguage(property, language)];
    if (!isEmpty(value)) {
        return value;
    }
 
    if (strict) {
        return undefined;
    }
 
    let result;
    ["Fr", "Nl", "En"].forEach((lng) => {
        const val = resource[`${property}${lng}`];
        if (!isEmpty(val)) {
            result = val;
        }
    });
    return result === undefined ? undefined : result;
}; 

export const getAuthorName = (author) => {
    if (author?.signature?.title) return author.signature.title;
  
    const name = `${author?.firstName || ""} ${author?.lastName || ""}`.trim();
    return name;
  };

export const processArticleContent = (htmlString) => {
    if (!htmlString) return "";

    const doc = new DOMParser().parseFromString(htmlString, "text/html");

    const spans = doc.querySelectorAll("span");

    spans.forEach((span) => {
      if (span.textContent.trim() === "aaaa") {
        let next = span.nextSibling;
        while (next) {
          if (next.nodeName === "BR") {
            next.remove();
            break;
          }
          if (
            next.nodeType === Node.ELEMENT_NODE &&
            next.nodeName !== "BR"
          ) {
            break;
          }
          next = next.nextSibling;
        }
      }
    });

    return doc.body.innerHTML;
  };